window.Admin.WaitlistRequests = {}